<template>
  <div
    v-if="types.length > 1"
    :style="{ display: 'inline-flex', gap: '2px', padding: '3px', borderRadius: '9px', background: 'var(--p-overlay-popover-background)' }"
  >
    <button
      v-for="[v, icon, label] in types"
      :key="v"
      :title="label"
      :aria-label="label"
      :style="{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '26px',
        borderRadius: '7px',
        cursor: 'pointer',
        border: 0,
        background: value === v ? 'var(--p-content-background)' : 'transparent',
        color: value === v ? 'var(--p-text-color)' : 'var(--p-surface-400)',
        boxShadow: value === v ? '0 1px 2px rgba(0,0,0,.18)' : 'none',
      }"
      @click="emit('change', v)"
    >
      <i :class="`pi pi-${icon}`" :style="{ fontSize: '13px' }" />
    </button>
  </div>
</template>

<script setup>
// Segmented view-type switch (List / Grid / Table), plus any custom `extra`
// views. Hidden when only one type is available. Ported from collection-frame.
import { computed } from 'vue'

const VIEW_TYPES = [
  ['list', 'bars', 'List'],
  ['grid', 'th-large', 'Grid'],
  ['table', 'table', 'Table'],
]

const props = defineProps({
  value: { type: String, default: 'list' },
  allowed: { type: Array, default: null },
  extra: { type: Array, default: null },
})
const emit = defineEmits(['change'])

const types = computed(() => {
  let t = props.allowed && props.allowed.length ? VIEW_TYPES.filter(([v]) => props.allowed.includes(v)) : VIEW_TYPES.slice()
  if (props.extra && props.extra.length) t = [...t, ...props.extra]
  return t
})
</script>
